import React from "react";

const Table = ({ responsive, striped, hover, bordered, size, className, style, children }) => {
  const cls = [
    "table",
    striped ? "table-striped" : "",
    hover ? "table-hover" : "",
    bordered ? "table-bordered" : "",
    size ? `table-${size}` : "",
    className || "",
  ].filter(Boolean).join(" ");

  const table = <table className={cls} style={style}>{children}</table>;
  if (responsive) return <div className="table-responsive">{table}</div>;
  return table;
};

export default Table;
